<template>
<v-container fluid grid-list-lg style="min-height:100%">

  <span class="centerized title grey--text text-xs-center" v-if="!loading && Object.keys(userFace).length===0">{{ $t('face.no_faces_existed') }}</span>

  <v-layout row wrap v-else-if="!loading">
    <v-flex xs12 sm6 md6 lg4 xl3 v-for="f in sortedFaces" :key="f.FaceId">
      <facelabeling-item :face="f" @edit="editFaceName"></facelabeling-item>
    </v-flex>
  </v-layout>

  <facelabeling-editor-dialog v-if="editFaceNameDialog" v-model="editFaceNameDialog" :face="editFace" @toast="val=>$emit('toast',val)"></facelabeling-editor-dialog>

  <facelabeling-add-dialog v-if="addFaceDialog" v-model="addFaceDialog" :camera="allCamera" :shots="allShots" :width="500" @toast="val=>$emit('toast',val)"></facelabeling-add-dialog>

  <v-btn :disabled="!canAdd" color="secondary" dark fixed bottom right fab v-if="!loading" @click="addFaceDialog=true">
    <v-icon>add</v-icon>
  </v-btn>

  <progress-dialog :visible="loading">{{ $t('loading') }}</progress-dialog>

</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import FaceLabelingItem from './FaceLabelingItem'
import FaceLabelingAddDialog from './FaceLabelingAddDialog'
import FaceLabelingEditDialog from './FaceLabelingEditDialog'

export default {
  name: 'FaceLabeling',
  mixins: [UserAuth],
  components: {
    'facelabeling-item': FaceLabelingItem,
    'facelabeling-add-dialog': FaceLabelingAddDialog,
    'facelabeling-editor-dialog': FaceLabelingEditDialog
  },
  data() {
    return {
      userShot: {},
      userFaceImageUrl: {},
      editFace: null,
      editFaceNameDialog: false,
      addFaceDialog: false
    }
  },
  computed: {
    loading() {
      return this.faceLoading;
    },
    canAdd() {
      return Object.keys(this.userFace).length < 20;
    },
    allCamera() {
      let list = [];
      Object.values(this.userCamera).forEach(gateway => {
        Object.keys(gateway).forEach(id => {
          let device = gateway[id];
          let [mac, uid, cid] = id.split('-');
          let tn = ((this.userTargetName[mac] || {})[uid] || {})[cid];
          list.push({
            value: id,
            text: `${(this.userMacInfo[mac]||{}).hostname || mac} ${tn || device.name}`
          });
        });
      });
      return list;
    },
    allShots() {
      return this.userShot;
    },
    sortedFaces() {
      return Object.values(this.userFace).sort((a, b) => a.timestamp - b.timestamp);
    }
  },
  watch: {
    addFaceDialog(val) {
      if (val && Object.keys(this.userFace).length == 0) {
        this.createCollection();
      }
    }
  },
  methods: {
    createCollection() {
      let cmd = {
        user: this.userId,
        cmd: 'create'
      };
      this.$db.ref('command/face').push().set(cmd).catch(err => console.log(err.message));
    },
    resetCollection() {
      let cmd = {
        user: this.userId,
        cmd: 'reset'
      };
      this.$db.ref('command/face').push().set(cmd).catch(err => console.log(err.message));
    },
    listFaces() {
      let cmd = {
        user: this.userId,
        cmd: 'list'
      };
      this.$db.ref('command/face').push().set(cmd).catch(err => console.log(err.message));
    },
    editFaceName(f) {
      this.editFace = f;
      this.editFaceNameDialog = true;
    }
  },
  mounted() {
    this.$bindAsObject('userShot', this.$db.ref('userShot').child(this.userId));
  },
  beforeDestroy() {
    this.$db.ref('userShot').child(this.userId).off();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cast/FaceLabeling.vue